import { render } from "./DashboardPromoBanner.vue?vue&type=template&id=acdd889a"
import script from "./DashboardPromoBanner.vue?vue&type=script&lang=js"
export * from "./DashboardPromoBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__